import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { full } from "./shared/routes/full.routes";
import { content } from "./shared/routes/routes";
import { OauthComponent } from "./components/dashboard/default/oauth-component/oauth-component";
import { AuthGuard } from './shared/guard/admin.guard';
import { DownloadComponent } from './auth/download/download.component';
import { Tokenverify } from './auth/tokenverify/tokenverify';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard/default',
        pathMatch: 'full'
    },
    {
        path: 'auth/login',
        component: LoginComponent
    },
    {
        path: 'download',
        component: DownloadComponent
    },
    {
        path: 'oauth',
        component: OauthComponent
    },
    {
        path: 'tokenverify',
        component: Tokenverify
    },
    {
        path: '',
        component: ContentComponent,
        canActivate: [AuthGuard],
        children: content
    },
    {
        path: '',
        component: FullComponent,
        canActivate: [AuthGuard],
        children: full
    },
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }